
import {Component, Vue} from "vue-property-decorator";
import i18n from "../plugins/vue-i18n";
import HelloWorld from "@/components/HelloWorld.vue";
import SidebarComptage from "@/components/comptage/SidebarComptage.vue";
import SettingsComptage from "@/components/comptage/SettingsComptage.vue";
import FiltersComptage from "@/components/comptage/FiltersComptage.vue";
import ExportComptage from "@/components/comptage/ExportComptage.vue";
import DataComptage from "@/components/comptage/DataComptage.vue";
import {namespace} from "vuex-class";
import IComptage from "../types/comptage.interface";
import comptageService from "../services/comptage.service";
import filterService from "../services/filter.service";
import panierService from "@/services/panier.service";
import enrichissementService from "@/services/enrichissement.service";
import preferencesService from "@/services/preferences.service";
import IFiltersComptage from "@/types/filters-comptage.interface";
import ISolvability from "@/types/solvability.interface";
import dataService from "@/services/data.service";
import IEnrichissement from "@/types/enrichissement.interface";

const userModule = namespace("userModule");
const panierModule = namespace("panierModule");

@Component({
    components: {
        HelloWorld,
        SidebarComptage,
        SettingsComptage,
        FiltersComptage,
        ExportComptage,
        DataComptage,
    },
})
export default class Comptage extends Vue {
    tab = null;
    stepper = 1;
    items = [
        {tab: i18n.tc("comptage.tabs.settings"), content: "SettingsComptage", step: 1},
        {tab: i18n.tc("comptage.tabs.filters"), content: "FiltersComptage", step: 2},
        {tab: i18n.tc("comptage.tabs.data"), content: "DataComptage", step: 3},
        {tab: i18n.tc("comptage.tabs.export"), content: "ExportComptage", step: 4},
    ];
    previews = [];
    headers = [];
    isLoadingData = false;
    isLoadingPreview = false;
    isSavingPreference = false;
    dialogPreview = false;
    saveModal = false;
    initialProduct: IComptage = this.emptyComptage();
    previousProduct: IComptage = null;
    currentProduct: IComptage = this.emptyComptage();
    productId: string = null
    preferenceTrigger = true;
    resetTrigger = true;
    preferenceUpdate = false;
    selectedExportFormat = null;
    basket = null;
    initialization = false;
    modalType = '';
    futureTypeValue: string = null;
    setStep = false;
    dataTypes = [];
    loadingFilter = false;
    snackbar = false;
    snacktext = '';
    saveType = 0;
    comptageFile = null;
    dataToAdd = [];

    @userModule.State
    public user!: any;

    @userModule.Action
    public setTempComptage!: (product: IComptage) => void;

    @panierModule.Action
    public addProduct!: () => void;

    @panierModule.Mutation
    public setItemCat!: (itemCat: string) => void;

    filters: any = {};

    result = {
        nb: 0,
        credits: 0,
    };

    refreshResult() {
        this.updateComptage();
        if (!this.initialization && JSON.stringify(this.currentProduct) !== JSON.stringify(this.previousProduct)) {
            this.isLoadingData = true;
            comptageService
                .getNbCounted(this.currentProduct)
                .then((res) => {
                    this.result = res.data.message;
                    this.previousProduct = JSON.parse(JSON.stringify(this.currentProduct));
                    this.isLoadingData = false;
                    if (!this.preferenceUpdate) {
                        this.setTempComptage(this.currentProduct);
                    } else {
                        this.setTempComptage(this.emptyComptage());
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            this.isLoadingData = false;
        }
    }

    setDataTypes() {
        const identity = {
            id: 0,
            key: "identity",
            filter: this.currentProduct.type === 'etablissement' ? "siret_etablissement" : "siren_societe",
            name: this.currentProduct.type === 'etablissement' ? i18n.tc('siret') : i18n.tc('siren'),
            disabled: true
        };
        this.dataTypes = dataService.generateDataTypes(identity, this.currentProduct.type !== 'etablissement');
    }

    applyPreference(product: IComptage) {
        if (product) {
            this.currentProduct = JSON.parse(JSON.stringify(product));
            this.setDataTypes();
            this.preferenceUpdate = true;
            this.refreshResult();
        } else {
            this.currentProduct = JSON.parse(JSON.stringify(this.initialProduct));
            this.setDataTypes();
            this.resetTrigger = !this.resetTrigger;
            this.preferenceUpdate = false;
            this.refreshResult();
        }
    }

    applyProductType() {
        this.currentProduct = this.emptyComptage();
        this.currentProduct.type = this.futureTypeValue;
        this.setDataTypes();

        if (this.futureTypeValue === 'etablissement')
            this.currentProduct.datas = [{
                id: 0,
                key: "identity",
                filter: 'id',
                name: i18n.tc('siret'),
                disabled: false
            }];
        this.futureTypeValue = null;
        this.preferenceUpdate = false;
        this.resetTrigger = !this.resetTrigger;
        this.refreshResult();
    }

    comptageIsEmpty() {
        const emptyProduct = this.emptyComptage();
        const currentFilters = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(this.currentProduct.filters)));
        const emptyFilters = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(emptyProduct.filters)));
        const currentFilteredFilters = currentFilters.filter(c => this.currentProduct.filters[c] && (Object.keys(this.currentProduct.filters[c]).length > 0 || this.currentProduct.filters[c].length > 0));
        const emptyFilteredFilters = emptyFilters.filter(c => emptyProduct.filters[c] && (Object.keys(emptyProduct.filters[c]).length > 0 || emptyProduct.filters[c].length > 0));
        return currentFilteredFilters.length === 1 &&
            emptyFilteredFilters.length === 1 &&
            this.currentProduct.filters[currentFilteredFilters[0]].ceasedActivity === false &&
            emptyProduct.filters[currentFilteredFilters[0]].ceasedActivity === false &&
            this.currentProduct.filters[currentFilteredFilters[0]].collectiveProcedure === false &&
            emptyProduct.filters[currentFilteredFilters[0]].collectiveProcedure === false &&
            this.currentProduct.filters[currentFilteredFilters[0]].certifiedRisk === true &&
            emptyProduct.filters[currentFilteredFilters[0]].certifiedRisk === true &&
            this.currentProduct.filters[currentFilteredFilters[0]].veryHighRisk === true &&
            emptyProduct.filters[currentFilteredFilters[0]].veryHighRisk === true &&
            this.currentProduct.filters[currentFilteredFilters[0]].highRisk === true &&
            emptyProduct.filters[currentFilteredFilters[0]].highRisk === true &&
            this.currentProduct.filters[currentFilteredFilters[0]].mediumRisk === true &&
            emptyProduct.filters[currentFilteredFilters[0]].mediumRisk === true &&
            this.currentProduct.filters[currentFilteredFilters[0]].lowRisk === true &&
            emptyProduct.filters[currentFilteredFilters[0]].lowRisk === true &&
            this.currentProduct.filters[currentFilteredFilters[0]].veryLowRisk === true &&
            emptyProduct.filters[currentFilteredFilters[0]].veryLowRisk === true &&
            this.currentProduct.datas.length === 1 &&
            emptyProduct.datas.length === 1 &&
            this.currentProduct.datas[0].id === 0 &&
            this.currentProduct.files.length === 0 &&
            emptyProduct.files.length === 0
    }

    setProductType(value) {
        if (!this.comptageIsEmpty()) {
            this.modalType = 'changeType';
            this.futureTypeValue = value;
            this.saveModal = true;
            this.snackbar = false;
        } else {
            this.futureTypeValue = value;
            this.applyProductType();
        }
    }

    created() {
        this.setItemCat("Comptage");
        this.isLoadingData = true;
        this.initialization = true;
        this.loadingFilter = true;
        this.filters = {};
        if (localStorage.getItem('naf')) {
            this.loadingFilter = false;
            this.filters.naf = JSON.parse(localStorage.getItem('naf'));
        }
        if (localStorage.getItem('juridique')) {
            this.filters.categoriesJuridique = JSON.parse(localStorage.getItem('juridique'));
        }
        filterService.getFilters().then((filtersRes) => {
            this.filters = filtersRes.data;
            localStorage.setItem('naf', JSON.stringify(this.filters.naf));
            localStorage.setItem('juridique', JSON.stringify(this.filters.categoriesJuridique));
            this.loadingFilter = false;
        });
        if (this.$route.params.id) {
            panierService.getFileFromId(this.$route.params.id).then((res) => {
                // TODO : reconstituer le ISolvability à partir des intervalles ?
                this.initialProduct = res.data.message.basket.Items[0].filters;
                this.currentProduct = res.data.message.basket.Items[0].filters;
                const identity = this.currentProduct.type === 'etablissement' ? {
                    id: 0,
                    key: "identity",
                    filter: 'id',
                    name: i18n.tc('siret'),
                    disabled: true
                } : {
                    id: 0,
                    key: "identity",
                    filter: 'id',
                    name: i18n.tc('siren'),
                    disabled: true
                };
                this.currentProduct.datas = [identity, ...this.currentProduct.datas];
                this.basket = res.data.message.basket.Items[0];
                this.productId = this.currentProduct.id;
                this.initialization = false;
                this.comptage = res.data.message.basket.Items[0].filters;
                this.refreshResult();
                this.setDataTypes();
                this.dataToAdd = this.comptage.datas;
            });
        } else if (localStorage.getItem('comptage')) {
            this.initialProduct = this.emptyComptage();
            if (localStorage.getItem('comptageTime')) {
                const comptageTime = Number(localStorage.getItem('comptageTime'));
                if (Date.now() - comptageTime < 86400000) {
                    const product = JSON.parse(localStorage.getItem('comptage'));
                    // try to sort by index => doesn't work
                    if (product.datas.filter(d => d.i).length === product.datas.length) {
                        product.datas = product.datas.sort((a, b) => a.i - b.i);
                    }
                    this.productId = product.id;
                    this.currentProduct = product;
                    this.initialization = false;
                    this.refreshResult();
                } else {
                    localStorage.removeItem('comptage');
                    localStorage.removeItem('comptageTime');
                    this.currentProduct = this.emptyComptage();
                    this.initialization = false;
                    this.refreshResult();
                }
            } else {
                this.currentProduct = this.emptyComptage();
                this.initialization = false;
                this.refreshResult();
            }
        } else {
            this.currentProduct = this.emptyComptage();
            this.initialization = false;
            this.refreshResult();
        }
        if (this.$route.query.step && typeof (this.$route.query.step) === 'string') {
            this.stepper = parseInt(this.$route.query.step);
        } else {
            this.stepper = 1;
        }
        this.setDataTypes();
        this.dataToAdd = this.comptage.datas;
        // setTimeout(() => this.currentProduct.datas = JSON.parse(JSON.stringify(this.currentProduct.datas)), 300);
    }

    emptyComptage(): IComptage {
        return {
            id: null,
            uuid: null,
            name: "",
            type: "entreprise",
            filters: {
                activity: [],
                legal: [],
                geolocation: [],
                score: {
                    ceasedActivity: false,
                    collectiveProcedure: false,
                    certifiedRisk: true,
                    veryHighRisk: true,
                    highRisk: true,
                    mediumRisk: true,
                    lowRisk: true,
                    veryLowRisk: true
                },
                effectif_bilan: {},
                ca_bilan: {},
                date_immatriculation: {},
                date_creation_bilan: {},
                effectif_groupe: {},
                ca_groupe: {},
                hasPhone: false,
                hasGroup: false,
                hasEmail: false,
                hasDirector: false,
                hasOperationalDirector: false,
            },
            files: [],
            datas: [{id: 0, key: "identity", filter: 'id', name: i18n.tc('siren'), disabled: true}],
            productId: null
        };
    }

    updatePreference(preference: IComptage) {
        this.preferenceUpdate = true;
        this.currentProduct = JSON.parse(JSON.stringify(preference));
        this.snackbar = true;
    }

    order(modify: boolean) {
        this.isLoadingData = true;
        localStorage.removeItem('comptage');
        const id = Date.now();
        const product = {
            id: id,
            type: "comptage",
            segment: this.currentProduct.type !== 'entreprise',
            date: new Date().toLocaleDateString(),
            results: this.result.nb,
            credits: this.result.credits,
            format: "csv",
            content: JSON.parse(JSON.stringify({...this.currentProduct, ...{productId: id}}))
        };
        product.content.datas = product.content.datas.filter(d => d.id !== 0);
        this.modalType = 'order';
        if (modify) {
            panierService.putBasket(this.basket.basketId, null, product.results, product.credits, product.format, product.segment, product.type, this.user.id, this.basket.basketStatus, this.user.email, product.content).then(res => {
                this.saveModal = true;
                this.snackbar = false;
                this.isLoadingData = false;
            });
        } else {
            panierService.postFile(null, product.results, product.credits, product.format, product.segment, product.type, this.user.id, product.content).then(res => {
                this.addProduct();
                this.saveModal = true;
                this.snackbar = false;
                this.isLoadingData = false;
            });
        }
    }

    previewData() {
        this.headers = [];
        this.previews = [];
        this.isLoadingPreview = true;

        comptageService.preview(this.currentProduct).then((res: any) => {
            const ids = [];

            let type = 'siren';
            if (this.currentProduct.type == 'etablissement') {
                type = 'siret'
            }

            for (let index = 0; index < res.data.message.items.length; index++) {
                const element = res.data.message.items[index];
                ids.push(element[type])
            }
            enrichissementService.previewComptage({
                type: type,
                datas: this.currentProduct.datas.filter(d => d.id !== 0),
                ids: ids
            }).then((resPreview: any) => {
                this.headers = this.createdHeadersFile(resPreview.data.message);
                // To put label header instead of technical column header
                /*
                const finalArray = [];
                finalArray[0] = Object.values(resPreview.data.message[0]).map(m => i18n.tc('enrichissement.data.datas.' + m));
                for (let index = 1; index < resPreview.data.message.length; index++) {
                    finalArray.push(resPreview.data.message[index]);
                }
                this.previews = finalArray;
                 */
                const tempPreviews = resPreview.data.message;
                tempPreviews.shift();
                this.previews = tempPreviews;
                this.dialogPreview = true;
                this.isLoadingPreview = false;
            });
        });
    }

    createdHeadersFile(items) {
        const headers = [];
        if (items && items.length > 0) {
            /*
            const length = Object.keys(items[0]).length;
            for (let index = 1; index < length; index++) {
                const key = Object.keys(items[0])[index];
                headers.push({
                    text: items[0][key],
                    value: key
                });
            }
             */
            for (const key in Object.keys(items[0]).filter(k => k !== 'lineId')) {
                headers.push({
                    text: items[0][key],
                    value: key
                });
            }
        }
        return headers;
    }

    savePreferenceFilter(preferenceUpdate) {
        this.saveType = 2;
        this.isSavingPreference = true;
        this.updateComptage();
        preferencesService.savePreferenceFilter(this.currentProduct, this.user.id, 'comptage').then(() => {
            this.preferenceTrigger = !this.preferenceTrigger;
            this.isSavingPreference = false;
        });
        this.snacktext = preferenceUpdate ? i18n.tc('preferences_updated') : i18n.tc('preferences_saved');
        this.snackbar = true;

    }

    public comptage: IComptage = {
        datas: [],
        files: [],
        productId: null,
        type: null
    };

    updateComptage() {
        this.comptage.datas = this.currentProduct.datas;
        this.comptage.files = JSON.parse(JSON.stringify(this.currentProduct.files));
    }

    resetProduct() {
        this.currentProduct = JSON.parse(JSON.stringify(this.initialProduct));
        this.currentProduct.files = [];
        this.resetTrigger = !this.resetTrigger;
        this.preferenceUpdate = false;
        this.stepper = 1;
        this.dataToAdd = this.comptage.datas;
        this.refreshResult();
    }

    setActivities(activities) {
        this.$set(this.currentProduct.filters, 'activity', activities);
        this.refreshResult();
    }

    setLegal(legal) {
        this.$set(this.currentProduct.filters, 'legal', legal);
        this.refreshResult();
    }

    setGeolocation(geolocation) {
        this.$set(this.currentProduct.filters, 'geolocation', geolocation);
        this.refreshResult();
    }

    setScore(key: string, value: boolean) {
        this.$set(this.currentProduct.filters.score, key, value);
        this.setFullScore(this.currentProduct.filters.score);
    }

    setFullScore(score: ISolvability) {
        this.$set(this.currentProduct.filters, 'score', score);
        this.refreshResult();
    }

    setKeyNumbers(key: string, field: string, value1: string, value2: string) {
        const keyNumbersMap = comptageService.keyNumbersMap();
        if (field === 'both') {
            if (this.currentProduct.filters[key].value) {
                delete this.currentProduct.filters[key].value;
            }
            if (!value1 || value1 == '0' || value1 == '') {
                this.$set(this.currentProduct.filters[key], 'min', null);
            } else {
                this.$set(this.currentProduct.filters[key], 'min', keyNumbersMap[key].type === 'number' ? Number(value1) : value1);
            }
            if (!value2 || value2 == '0' || value2 == '') {
                this.$set(this.currentProduct.filters[key], 'max', null);
            } else {
                this.$set(this.currentProduct.filters[key], 'max', keyNumbersMap[key].type === 'number' ? Number(value2) : value2);
            }
            this.refreshResult();
        } else if (field === 'value') {
            if (this.currentProduct.filters[key].min || this.currentProduct.filters[key].min) {
                delete this.currentProduct.filters[key].min;
                delete this.currentProduct.filters[key].max;
            }
            if (!value1) {
                this.$set(this.currentProduct.filters[key], field, null);
            } else {
                this.$set(this.currentProduct.filters[key], field, keyNumbersMap[key].type === 'number' ? Number(value1) : value1);
            }
            this.refreshResult();
        }
    }

    setAdvanced(key: string, value: boolean) {
        this.currentProduct.filters[key] = value;
        this.refreshResult();
    }

    uploadDataToAdd(data) {
        this.currentProduct.datas = data;
        this.refreshResult();
    }

    uploadFileToAdd(files) {
        this.currentProduct.files = files;
        this.refreshResult();
    }

    filterLegal(filterItem: any) {
        const arrayToFilter = comptageService.getChildren(filterItem).map(a => a.code);
        const newLegal = this.currentProduct.filters.legal.filter(a => arrayToFilter.indexOf(a.code) === -1);
        this.setLegal(newLegal);
    }

    filterActivity(filterItem: any) {
        const arrayToFilter = comptageService.getChildren(filterItem).map(a => a.code);
        const newActivities = this.currentProduct.filters.activity.filter(a => arrayToFilter.indexOf(a.code) === -1);
        this.setActivities(newActivities);
    }

    filterGeolocation(filterItem: any) {
        const arrayToFilter = comptageService.getChildren(filterItem).map(a => a.code);
        const newGeolocations = this.currentProduct.filters.geolocation.filter(g => arrayToFilter.indexOf(g.code) === -1);
        this.setGeolocation(newGeolocations);
    }

    filterScore(item: any) {
        this.currentProduct.filters.score[item.code] = false;
        this.setFullScore(this.currentProduct.filters.score);
    }

    filterKeyNumbers(item: any) {
        this.currentProduct.filters[item.code] = {};
        // delete twice so watch detects everything
        setTimeout(() => this.currentProduct.filters[item.code] = {}, 300);
        this.refreshResult();
    }

    filterAdvanced(item) {
        this.currentProduct.filters[item.code] = false;
        this.refreshResult();
    }

    filterFiles(item) {
        this.currentProduct.files = this.currentProduct.files.filter(f => f.uuid !== item.uuid);
        this.refreshResult();
    }

    removeDataToAdd(data) {
        if (data.id) {
            this.currentProduct.datas = this.currentProduct.datas.filter(obj => obj.id !== data.id);
            this.refreshResult();
        } else {
            this.currentProduct.datas = this.currentProduct.datas.filter(obj => obj.key !== data.key || obj.disabled);
            // setTimeout(() => this.currentProduct.datas = this.currentProduct.datas.filter(obj => obj.key !== data.key || obj.disabled), 300);
            this.refreshResult();
        }
    }

    removeItemFromFilter(key: keyof IFiltersComptage | string, filterItem: any) {
        (this.currentProduct.filters[key] as any[]) = (this.currentProduct.filters[key] as any[])
            .filter((item: any) => item.code !== filterItem.code);
        this.refreshResult();
    }

    uploadFormat(format) {
        this.selectedExportFormat = format;
    }

    previewCss(value) {
        const words = value.split(' ');
        const longest = words.reduce((a, b) => a.length > b.length ? a : b);
        if (longest.length > 15 || value.length > 25) {
            return 'big-preview-header';
        } else if (longest.length > 10 || value.length > 15) {
            return 'medium-preview-header';
        } else {
            return 'preview-header';
        }
    }

    savePreference(update) {
        this.saveType = 1;
        this.preferenceTrigger = !this.preferenceTrigger;
        this.preferenceUpdate = false;
        this.snacktext = update ? i18n.tc('preferences_updated') : i18n.tc('preferences_saved');
        this.snackbar = true;
    }
}
